import { CreateProjectFormStep } from "@/pages/projects/forms/create/types";

export const CREATE_PROJECT_FORM_STEPS: CreateProjectFormStep[] = [
  CreateProjectFormStep.SELECT_PROJECT_SOURCES,
  CreateProjectFormStep.CONFIGURE_PROJECT,
  CreateProjectFormStep.SELECT_MAPPING_METHOD,
];

export const PROJECT_SYNC_NONE_CRON_EXPRESSION = "";
export const PROJECT_SYNC_HOURLY_CRON_EXPRESSION = "0 * * * *";
export const PROJECT_SYNC_DAILY_CRON_EXPRESSION = "0 0 * * *";
export const PROJECT_SYNC_WEEKLY_CRON_EXPRESSION = "0 0 * * 1";
export const PROJECT_SYNC_MONTHLY_CRON_EXPRESSION = "0 0 1 * *";

export const PROJECT_SYNC_SCHEDULE_OPTIONS = [
  {
    id: "none",
    label: "No schedule",
    cronExpression: PROJECT_SYNC_NONE_CRON_EXPRESSION,
  },
  {
    id: PROJECT_SYNC_HOURLY_CRON_EXPRESSION,
    label: "Hourly",
    cronExpression: PROJECT_SYNC_HOURLY_CRON_EXPRESSION,
  },
  {
    id: PROJECT_SYNC_DAILY_CRON_EXPRESSION,
    label: "Daily",
    cronExpression: PROJECT_SYNC_DAILY_CRON_EXPRESSION,
  },
  {
    id: PROJECT_SYNC_WEEKLY_CRON_EXPRESSION,
    label: "Weekly",
    cronExpression: PROJECT_SYNC_WEEKLY_CRON_EXPRESSION,
  },
  {
    id: PROJECT_SYNC_MONTHLY_CRON_EXPRESSION,
    label: "Monthly",
    cronExpression: PROJECT_SYNC_MONTHLY_CRON_EXPRESSION,
  },
] as const;
